import { Arrow } from 'konva/lib/shapes/Arrow';

import { AnnotateComponentActionShape, AnnotateComponentState } from './annotate-component';
import { AnnotatePathComponent } from './annotate-path-component';

export class AnnotateComponentArrow extends AnnotatePathComponent {

    readonly transformerAnchors = ['bottom-right'];
    readonly drawingShapeDefaultConfig = {
        hitStrokeWidth: 30,
        points: [0, 0, 150, 0],
    };
    readonly drawingShape: Arrow;

    constructor(
        uuid: string,
        state: AnnotateComponentState,
    ) {
        super(uuid, AnnotateComponentActionShape.ARROW, state);

        this.drawingShape = new Arrow({ ...this.drawingShapeDefaultConfig, ...state.config });
        this.drawingLayer.add(this.drawingShape);

        this.addDraggablePoints();
        this.draw();
    }

    updateState() {
        super.updateState();

        if (this.state.config) {
            this.state.config.points = this.drawingShape.points();
        }
    }

}
